import { render, staticRenderFns } from "./main_slider.vue?vue&type=template&id=22add927&scoped=true&"
import script from "./main_slider.vue?vue&type=script&lang=js&"
export * from "./main_slider.vue?vue&type=script&lang=js&"
import style0 from "./main_slider.vue?vue&type=style&index=0&id=22add927&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22add927",
  null
  
)

export default component.exports